import { render, staticRenderFns } from "./psSettlementHistory.vue?vue&type=template&id=be561260&scoped=true"
import script from "./psSettlementHistory.vue?vue&type=script&lang=js"
export * from "./psSettlementHistory.vue?vue&type=script&lang=js"
import style0 from "./psSettlementHistory.vue?vue&type=style&index=0&id=be561260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be561260",
  null
  
)

export default component.exports